import { IProductPropsPDP } from 'store/modules/product';

import { SimpleProductCarousel } from 'components/common/Templates/Carousel/SimpleProductCarousel';

interface RatingProps {
  correlatados: IProductPropsPDP[];
}

import * as S from './styles';

export function Correlatos({ correlatados }: RatingProps) {
  return (
    <S.Container className="correlatos">
      <div className="correlatos-title">
        <img src="/images/icons/search-list.svg" alt="Search" />
        <span>Produtos similares:</span>
      </div>

      <SimpleProductCarousel items={correlatados} />
    </S.Container>
  );
}
